import axios from './http'
let BASE_URL = "/api/v2";
const api = {
    loginZh(para) {
        return axios.post(BASE_URL + '/log/submitZhLogin', para)
    },
    loginCa(para) {
        return axios.post(BASE_URL + '/log/submitCALogin', para)
    },
    getLoginEwm() {
        return axios.post(BASE_URL + '/log/toQrcodeView')
    },
    setSrcLogin(para) {
        return axios.post(BASE_URL + '/log/getDataByUuid', para)
    },
    ewmLogin(para) {
        return axios.post(BASE_URL + '/log/ewmLogin', para)
    },
    changeRyjs(para) {
        return axios.post(BASE_URL + '/log/changeRyjs', para)
    },
    //国家授时时间
    getGjsssj(para) {
        return axios.post(BASE_URL + '/kb/kbxm/gjsssj', para)
    },
    //退出
    loginOut() {
        return axios.post(BASE_URL + '/log/logOut')
    },
    //终止开标
    saveStopKb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zzkb', para)
    },
    //开标页面列表
    getkbxmList(para) {
        return axios.post(BASE_URL + '/index', para)
    },
    //进入流程
    kbxm(para) {
        return axios.post(BASE_URL + '/kb/kbxm/', para)
    },

    //提疑
    tyList(para) {
        return axios.post(BASE_URL + '/jc/tyhf/list', para)
    },
    saveTyhf(para) {
        return axios.post(BASE_URL + '/jc/tyhf/saveTyhf', para)
    },
    getkbxmlcTb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/getkbxmlcTb', para)
    },
    //摄像头
    getSxt(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zb', para)
    },
    getSxtAndLive(para) {
        return axios.get(BASE_URL + '/kb/kbxm/vod?bdId=' + para)
    },
    startPushStream(para) {
        return axios.post(BASE_URL + '/kb/kbxm/startPushStream', para)
    },
    //消息中心
    sendXx(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveXxzx', para)
    },
    getMsg(para) {
        return axios.post(BASE_URL + '/kb/kbxm/xxzxList', para)
    },
    getMoreMsg(para) {
        return axios.post(BASE_URL + '/kb/kbxm/xxzxMore', para)
    },
    //关闭开启发言
    kqfy(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kqfy', para)
    },
    //下一步按钮
    nextBtn(para) {
        return axios.post(BASE_URL + '/kb/kbxm/jrxyb', para)
    },
    //签到页面获取数据
    kbqdList(para) {
        return axios.post(BASE_URL + '/kb/kbqd/kbqdList', para)
    },

    //开启签到按钮
    kqqdBtn(para) {
        return axios.post(BASE_URL + '/kb/kbqd/kqkbqd', para)
    },
    //获取签到二维码
    getQdEwm() {
        return axios.post(BASE_URL + '/kb/kbqd/reqOneCR')
    },
    //验证签到二维码是否扫码
    setQdSrc(para) {
        return axios.post(BASE_URL + '/kb/kbqd/hqzsnrOne', para)
    },
    //ca签到
    caQd(para) {
        return axios.post(BASE_URL + '/kb/kbqd/tbdwqd', para)
    },
    //查询签到单位列表
    cxtbdwList(para) {
        return axios.post(BASE_URL + '/kb/kbqd/cxtbdwList', para)
    },
    ////////////////////////////投标人签到
    kbqdTbr(para) {
        return axios.post(BASE_URL + '/kb/kbqd/kbqdTbr', para)
    },
    //宣布纪律
    kbhcjl(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kbhcjl', para)
    },
    saveKbhcjl(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveKbhcjl', para)
    },
    //有效性审查
    yxxsc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/yxxscList', para)
    },
    //保存审查结果
    saveYxxsc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveYxxsc', para)
    },
    saveScfs(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveYxxscScfs', para)
    },
    //招标人确认审查结果
    qdscjg(para) {
        return axios.post(BASE_URL + '/kb/kbxm/yxxscQr', para)
    },
    //
    kpdjgbTbr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kpdjgbTbr', para)
    },
    ////////////////////////////投标人有效性审查
    yxxscTbr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/yxxscTbr', para)
    },
    //解密列表
    tbdwJmList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/tbdwJmList', para)
    },
    //开启解密
    kqjm(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kqjm', para)
    },
    //ca解密
    checkJm(para) {
        return axios.post(BASE_URL + '/kb/kbxm/checkJm', para)
    },
    //获取解密二维码
    getJmEwm() {
        return axios.get(BASE_URL + '/kb/kbxm/reqOneCRJm')
    },
    //验证解密二维码
    setJmSrc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/hqzsnrOneJm', para)
    },
    //获取投保人解密二维码
    getTbrJmEwm() {
        return axios.get(BASE_URL + '/kb/kbxm/reqCR')
    },
    //验证投保人解密二维码
    setTbrJmSrc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/hqzsnrTbr', para)
    },
    //投标人发起申请补救
    sqbj(para) {
        return axios.post(BASE_URL + '/kb/kbxm/sqbj', para)
    },
    //获取申请补救列表
    getSqbjList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/sqbjList', para)
    },
    //同意拒绝补救申请
    jssqbj(para) {
        return axios.post(BASE_URL + '/kb/kbxm/jssqbj', para)
    },
    //保存提交补救文件
    saveBj(para) {
        return axios.post(BASE_URL + '/kb/kbxm/bjwj', para)
    },
    ////////////////////////////投标人解密
    tbdwJmTbr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/tbdwJmTbr', para)
    },
    tbdwJmDetail(para) {
        return axios.post(BASE_URL + '/kb/decrypt/detail', para)
    },
    //监狱询比唱标
    getCkQdtbdwList(para) {
        return axios.post(BASE_URL + '/kb/xbKbxm/ckQdtbdwList', para)
    },
    getCbList(para) {
        return axios.post(BASE_URL + '/kb/xbKbxm/cbList', para)
    },
    //龙游唱标
    getLyCbList(para) {
        return axios.post(BASE_URL + "/kb/xbKbxm/lycbList", para)
    },

    //获取唱标规则
    lookRule() {
        return axios.get(BASE_URL + "/kb/kpytKbxm/lookRule")
    },
    xbcbTbrList(para) {
        return axios.post(BASE_URL + "/kb/xbKbxm/xbcbTbrList", para)

    },
    getDcbjList(para) {
        return axios.post(BASE_URL + '/kb/xbKbxm/dcbjList', para)
    },
    // 开启下轮报价
    openMultipleQuotes(para) {
        return axios.post(BASE_URL + '/kb/xbKbxm/openMultipleQuotes', para)
    },
    //公布报价
    publishPrice() {
        return axios.post(BASE_URL + '/kb/xbKbxm/publishPrice')
    },
    //获取报价公开状态
    checkPublishPrice() {
        return axios.get(BASE_URL + '/kb/xbKbxm/checkPublishPrice')
    },
    // 提前结束
    endMultipleQuotes(para) {
        return axios.post(BASE_URL + '/kb/xbKbxm/endMultipleQuotes', para)
    },

    // 计算价格
    cscqnrCalculate(para) {
        return axios.post(BASE_URL + '/kbxm/cscqnr/calculate', para)
    },

    // 报价校验
    checkMultipleQuotes(para) {
        return axios.get(BASE_URL + '/kb/xbKbxm/checkMultipleQuotes', para)
    },


    // 符合性审查列表
    kpytfhxscList(para) {
        return axios.post(BASE_URL + '/kb/kpytKbxm/fhxscList', para)
    },
    // 下一步判断
    checkfhxsc(para) {
        return axios.get(BASE_URL + '/kb/kpytKbxm/checkfhxsc')
    },
    // 龙游符合性审查列表
    xbfhxscList(para) {
        return axios.post(BASE_URL + '/kb/xbKbxm/fhxscList', para)
    },
    // 选项通过未通过
    saveZgsc(para) {
        return axios.post(BASE_URL + '/kb/kbxmdzgsc/saveZgsc', para)
    },
    // 推荐中标候选人
    xbzbhxrList(para) {
        return axios.post(BASE_URL + '/kb/xbKbxm/zbhxrList', para)
    },

    // 判断是否选择中标候选人
    getCandidateState(para) {
        return axios.get(BASE_URL + '/kb/xbKbxm/getCandidateState', para)
    },
    // 龙游推荐中标候选人
    kbzbhxrList(para) {
        return axios.post(BASE_URL + '/kb/kpytKbxm/zbhxrList', para)
    },
    // 龙游公布推荐中标候选人
    publishCandidate(para) {
        return axios.post(BASE_URL + '/kb/kpytKbxm/publishCandidate', para)
    },
    // 龙游获取公开推荐中标候选人
    listCandidate(para) {
        return axios.get(BASE_URL + '/kb/kpytKbxm/listCandidate', para)
    },
    // 设置中标候选人
    saveCandidate(para) {
        return axios.post(BASE_URL + '/kb/xbKbxm/saveCandidate', para)
    },
    // 保存抽取记录
    saveRecord(para) {
        return axios.post(BASE_URL + '/kb/extract-record/saveRecord', para)
    },
    // 查询抽取记录
    listExtractRecord(param) {
        return axios.post(BASE_URL + `/kb/extract-record/listExtractRecord`, param)
    },
    saveExtractNum(para) {
        return axios.post(BASE_URL + `/kb/kpytKbxm/saveExtractNum`, para)
    },
    //唱标
    getCbData(para) {
        return axios.post(BASE_URL + '/kb/kbjl/zdcbList', para)
    },
    getValueDTypes(para) {
        return axios.get(BASE_URL + '/kb/kbjl/getValueDTypes', para)
    },
    getKbxmCscqnrForm(para) {
        return axios.post(BASE_URL + '/kbxm/cscqnr/getKbxmCscqnrForm', para)
    },
    // 获取报价列表
    tbbjcsList(para) { return axios.get(BASE_URL + `/kb/tbbjcs/cs/list?bdId=${para.bdId}`) },
    // 获取清单列表
    tbbjcsQdlist(para) { return axios.get(BASE_URL + `/kb/tbbjcs/qd/list?bdId=${para.bdId}`) },
    // 保存报价清单
    tbdwSave(para) { return axios.post(BASE_URL + `/kb/tbbjcs/tbdw/save?bdId=${para.bdId}&bjcs=${para.bjcs}`, para.dataList) },
    // 获取报价状态
    checkPriceState(para) { return axios.get(BASE_URL + `/kb/tbbjcs/checkPriceState/${para}`) },

    //保存设置参数
    saveSzcs(para) {
        return axios.post(BASE_URL + '/kbxm/cscqnr/createKbxmCscqnr', para)
    },
    getPfjgTabs(para) {
        return axios.post(BASE_URL + '/kb/kbxm/gbpbjgpsx', para)
    },
    getPfjgList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/gbpbjgList', para)
    },
    dcpsjgb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/dcpsjgb', para, { responseType: 'blob' })
    },
    ////////////////////////////投标人唱标
    zdcbTbr(para) {
        return axios.post(BASE_URL + '/kb/kbjl/zdcbTbr', para)
    },
    //开启报表
    getkbbbData(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kbbb', para)
    },
    //自动确认
    postZdqr(para) {
        return axios.post(BASE_URL + '/kb/kbjl/zdqr', para)
    },
    //保存确认时间
    saveKqqrTime(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kqqr', para)
    },
    //生成报表
    scbb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/scbb', para)
    },
    //下载报表
    loadBb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/dcBb', para, { responseType: 'blob' })
    },
    getKpdjgb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kpdjgb', para)
    },
    loadKpdjgb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/downloadKqdjgb', para, { responseType: 'blob' })
    },
    ////////////////////////////投标人确认
    kbqrTbr(para) {
        return axios.post(BASE_URL + '/kb/kbjl/kbqrTbr', para)
    },
    djqrTbr(para) {
        return axios.post(BASE_URL + '/kb/kbjl/djqrTbr', para)
    },
    //符合性审查
    fhxscList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/fhxscList', para)
    },
    //一键审查
    fhxscYjps(para) {
        return axios.post(BASE_URL + '/kb/kbxm/fhxscYjps', para)
    },
    //获取投标单位列表
    getTbdwList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/fhxscSc', para)
    },
    //保存审查结果
    saveTbdw(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveFhxsc', para)
    },
    //下载结果
    dcFhxsc(para) {
        return axios.post(BASE_URL + '/kb/kbxm/dcFhxsc', para, { responseType: 'blob' })
    },
    //中标候选人
    zbhxrList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zbhxrList', para)
    },
    //下载中标候选人
    dcZbhxr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/dcZbhxr', para, { responseType: 'blob' })
    },
    //
    saveZbhxr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveZbhxr', para)
    },
    //名录库编号
    zbhxrBh(para) {
        return axios.post(BASE_URL + '/kb/kbxm/zbhxrBh', para)
    },
    //zygl
    getZygl(para) {
        return axios.post(BASE_URL + '/sys/account/resc', para)
    },
    saveZygl(para) {
        return axios.post(BASE_URL + '/sys/account/saveResc', para)
    },
    delZygl(para) {
        return axios.post(BASE_URL + '/sys/account/deleteResc', para)
    },
    //qxgl
    getQxgl(para) {
        return axios.post(BASE_URL + '/sys/account/auth', para)
    },
    //jsgl
    //yhgl
    //gsjggl
    getGsjg(para) {
        return axios.post(BASE_URL + '/jc/gsjg/list', para)
    },
    saveGsjg(para) {
        return axios.post(BASE_URL + '/jc/gsjg/saveGsjg', para)
    },
    delGsjg(para) {
        return axios.post(BASE_URL + '/jc/gsjg/deleteGsjg', para)
    },
    //lcpz
    getLcpz(para) {
        return axios.post(BASE_URL + '/lc/lcgl/lcdyList', para)
    },
    saveLcpz(para) {
        return axios.post(BASE_URL + '/lc/lcgl/saveLcdy', para)
    },
    delLcpz(para) {
        return axios.post(BASE_URL + '/lc/lcgl/deleteLcdy', para)
    },
    //lcgl
    getLcgl(para) {
        return axios.post(BASE_URL + '/lc/lcgl/lcglList', para)
    },
    saveLcgl(para) {
        return axios.post(BASE_URL + '/lc/lcgl/saveLcgl', para)
    },
    delLcgl(para) {
        return axios.post(BASE_URL + '/lc/lcgl/deleteLcgl', para)
    },
    enableOrdisableLcgl(para) {
        return axios.post(BASE_URL + '/lc/lcgl/qyOrJy', para)
    },
    getPbbf(para) {
        return axios.post(BASE_URL + '/lc/lcgl/getPbbf', para)
    },
    //mbgl
    getMbgl(para) {
        return axios.post(BASE_URL + '/jc/mb/list', para)
    },
    saveMbgl(para) {
        return axios.post(BASE_URL + '/jc/mb/saveMb', para)
    },
    delMbgl(para) {
        return axios.post(BASE_URL + '/jc/mb/deleteMb', para)
    },
    //kbsz
    getKbsz(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kbxmList', para)
    },
    saveKbsz(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveKbxm', para)
    },
    //dlgl
    getLoginRole(para) {
        return axios.post(BASE_URL + '/sys/account/roleLoginList', para)
    },
    saveLoginRole(para) {
        return axios.post(BASE_URL + '/sys/account/saveRoleLogin', para)
    },
    delLoginRole(para) {
        return axios.post(BASE_URL + '/sys/account/deleteRoleLogin', para)
    },
    // #region
    // 多次报价 新增api
    // 主持人多次报价界面展示
    dcbjquery(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/dcbjquery', { params: para })
    },
    postZzbj(para) {
        return axios.post(BASE_URL + '/kb/kbxmdcbj/zzbj', para)
    },
    // 设置最高价
    setZgxj(para) {
        return axios.post(BASE_URL + '/kb/kbxmdcbj/set_zgxj', para)
    },
    // 主持人点击开启再次报价按钮时调
    kqzcbj(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/kqzcbj', { params: para })
    },
    // 招标代理点击公布历史报价时调用
    overridepublish(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/overridepublish', { params: para })
    },
    // 投标人多次报价界面展示
    tbrdcbjquery(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/tbrdcbjquery', { params: para })
    },
    // 投标人进入界面填写报价是点击确定按钮时调用
    bjjeoverride(para) {
        return axios.post(BASE_URL + '/kb/kbxmdcbj/bjjeoverride', para)
    },
    // 进入唱标页面是判断是否公开历史报价
    ispublish(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/ispublish', { params: para })
    },
    isInit(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/cb', { params: para })
    },
    // 点击解密下一步
    savenext(para) {
        return axios.post(BASE_URL + '/kb/kbxmdcbj/savenext', para)
    },
    // 模糊查询
    querylike(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/querylike', { params: para })
    },
    // 多次查询 点击下一步
    savetbdw(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/savetbdw', { params: para })
    },
    // 查询保证金缴纳情况
    checkBzjzt(para) {
        return axios.post(BASE_URL + '/kb/kbxm/checkBzjzt', { params: para })
    },
    xzcsbb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/xzcsbb', { params: para })
    },
    downloadcsb(para) {
        return axios.post(BASE_URL + '/kb/kbjl/downloadcsb', para, { responseType: 'blob' })
    },
    judgeType(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/judgeType', { params: para })
    },
    hqcqz(para) {
        return axios.get(BASE_URL + '/kbxm/cscqnr/hqcqz', { params: para })
    },
    tyhfwdlist(para) {
        return axios.post(BASE_URL + '/jc/tyhf/wdlist', para)
    },
    jszlist(para) {
        return axios.post(BASE_URL + '/jc/tyhf/jszlist', para)
    },
    filebefore(para) {
        return axios.post(BASE_URL + '/jc/tyhf/filebefore', para)
    },
    uploadtyfile(para) {
        return axios.post(BASE_URL + '/jc/tyhf/uploadtyfile', para)
    },
    toSign(para) {
        return axios.get(BASE_URL + '/jc/tyhf/toSign', { params: para })
    },
    pdfshow(para) {
        return axios.post(BASE_URL + '/jc/tyhf/pdfshow', para, { responseType: 'blob' })
    },
    delpdf(para) {
        return axios.post(BASE_URL + '/jc/tyhf/delpdf', para)
    },
    pdfview(para) {  // 未使用
        return axios.get(BASE_URL + '/jc/tyhf/pdfview/' + para, { responseType: 'blob' })
    },
    tyhfForm(para) {
        return axios.post(BASE_URL + '/jc/tyhf/tyhfForm', para)
    },
    // 获取验证码图片
    getGeneratePicture(str) {
        return `/api/v3/basic/captcha/generate?uniString=${str}`
    },
    // #endregion
    xgcbjgzt(para) {
        return axios.post(BASE_URL + '/kb/kbxm/xgcbjgzt', para)
    },
    // #endregion
    //开评一体-----------资格符合性审查
    getListInfoByKbxmId(para) {
        return axios.post(BASE_URL + '/kb/kbjl/getListInfoByKbxmId', para)
    },
    saveComplianceReview(para) {
        return axios.post(BASE_URL + '/kb/kbjl/saveComplianceReview', para)
    },
    getComplianceReviewFlag(para) {
        return axios.post(BASE_URL + '/kb/kbjl/getComplianceReviewFlag', para)
    },
    getPbbfcsByKbxmId(para) {
        return axios.post(BASE_URL + '/kb/kbjl/getPbbfcsByKbxmId', para)
    },
    //计算
    calculateCommercialBidScore(para) {
        return axios.post(BASE_URL + '/kb/kbjl/calculateCommercialBidScore', para)
    },
    // 计算-新(根据列表接口中的newOrOld值判断调用新还是旧的接口)
    calculateCommercialBidScoreNew(para) {
        return axios.post(BASE_URL + '/kb/kbxmdzgsc/getmethodByDjlcId', para)
    },
    //资格符合性审查计算
    calculate(param) {
        return axios.post(BASE_URL + '/kb/kbjl/calculate', param)
    },
    oneKeyNoPass(para) {
        return axios.post(BASE_URL + '/kb/kbxmdzgsc/oneKeyNoPass', para)
    },
    oneKeyPass(para) {
        return axios.post(BASE_URL + '/kb/kbxmdzgsc/oneKeyPass', para)
    },
    // 获取符合性审查状态
    getFhxscState(para) {
        return axios.get(BASE_URL + '/kb/xbKbxm/getFhxscState')
    },
    //中标候选人
    getWinningCandidateList(para) {
        return axios.post(BASE_URL + '/kb/kbjl/getWinningCandidateList', para)
    },
    saveWinningCandidate(para) {
        return axios.post(BASE_URL + '/kb/kbjl/saveWinningCandidate', para)
    },
    getWinningCandidateFlag(para) {
        return axios.post(BASE_URL + '/kb/kbjl/getWinningCandidateFlag', para)
    },
    getReportFormList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/getReportFormList', para)
    },
    //生成报表
    scKpytKbjlb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/scKpytKbjlb', para)
    },
    //投标人页面
    //是否中标候选人
    checkCompanyWinningCandidate(para) {
        return axios.post(BASE_URL + '/kb/kbjl/checkCompanyWinningCandidate', para)
    },
    //查看投标文件
    zbwjtbdw(para) {
        return axios.post(BASE_URL + '/kb/kbjl/zbwjtbdw', para)
    },
    tbwjList(type) {
        return axios.get(BASE_URL + `/kb/kbjl/tbwjList/${type}`)
    },
    cktbwj(para) {
        return axios.post(BASE_URL + '/kb/kbjl/cktbwj', para, { responseType: 'blob' })
    },
    // 导出唱标信息
    exportCbInfo() {
        return axios.get(BASE_URL + '/kb/kbjl/cbjgExcel', {
            responseType: 'arraybuffer',  // 关键修改：指定响应类型为二进制流
            headers: {
                'Content-Type': 'application/json; charset=utf-8'  // 明确指定请求编码
            }
        })  
    },
    lookPdf(para) {
        return axios.post(BASE_URL + `/kb/xbKbxm/lookPdf/${para}`, '', { responseType: 'blob' })
    },

    packDownload(para) {
        return axios.post(BASE_URL + `/kb/xbKbxm/packDownload`, '', { responseType: 'blob' })
    },

    // #region 竞争性比选
    // 下一步
    bxNextBtn(para) {
        return axios.post(BASE_URL + '/kb/kbxm/bxrxyb', para)
    },
    // 获取流程
    drjjxm(para) {
        return axios.post(BASE_URL + '/kb/kbxm/drjjxm', para)
    },
    // 开标列表
    kblbList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/kblbList', para)
    },
    // 中标候选人列表
    tjzbhxrList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/tjzbhxrList', para)
    },

    // 推荐中标候选人
    bczbhxr(para) {
        return axios.post(BASE_URL + '/kb/kbxm/bczbhxr', para)
    },
    // 推荐中标候选人-投标单位列表
    ckQdtbdwList(para) {
        return axios.post(BASE_URL + '/kb/kbxm/ckQdtbdwList', para)
    },
    // 生成开标记录表
    sckbjlb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/sckbjlb', para)
    },
    // 开标记录表列表
    ckkbjlb(para) {
        return axios.post(BASE_URL + '/kb/kbxm/ckkbjlb', para)
    },
    isShowResultButton(para) {
        return axios.get(BASE_URL + '/kb/kbjl/isShowResultButton', { params: para })
    },
    getJmDetails(data) {
        return axios.post(`${BASE_URL}/kb/decrypt/tenderDecryptDetail`, data)
    },
    // 联合体标识列表
    getLhtqyData(para) {
        return axios.post(BASE_URL + '/kb/kbxm/getLhtqyData', para)
    },
    // 投标人进入界面填写 报价是点击确定按钮时调用(黄岩)
    hybjjeoverride(id, para) {
        return axios.post(BASE_URL + `/kb/kbxmdcbj/createBjdFile/${id}`, para)
    },
    hypdfshow(fileId) {
        return axios.get(BASE_URL + `/kb/kbxmdcbj/getDcbjPdf/${fileId}`, { responseType: 'blob' })
    },
    // 验证是 否签章
    hyConfirmSign(fileId, data) {
        return axios.post(BASE_URL + `/kb/kbxmdcbj/confirmSign/${fileId}`, data)
    },
    //下载报价单
    hyDownloadBjd(fileId) {
        return axios.post(BASE_URL + `/kb/kbxmdcbj/downloadBjd/${fileId}`, { responseType: 'blob' })
    },
    // 查询评标是否被废标
    checkPbState(para) {
        return axios.get(BASE_URL + '/kb/kbxmdcbj/getpszt', { params: para })
    },
    // IP地址查重
    checkIpRepeat() {
        return axios.post(BASE_URL + '/kb/kpytKbxm/checkIpRepeat')
    },
    // #region 有效性审查优化-2025-02-11
    // 选择审查方式（新接口，不含龙游）
    saveYxxscScfsNew(para) {
        return axios.post(BASE_URL + '/kb/kbxm/saveYxxscScfsNew', para);
    },
    // 修改有效性审查
    updateValidityReview(para) {
        return axios.post(BASE_URL + '/kb/kbxm/updateValidityReview', para);
    },
    // 获取有效性审查修改记录
    getModificationRecord(para) {
        return axios.get(BASE_URL + `/kb/kbxm/viewReviewRecord?bdId=${para.bdId}`);
    },
    // 重新审查
    reReview(para) {
        return axios.get(BASE_URL + `/kb/kbxm/reReview`, { params: para });
    },
    // 查看文件
    viewFile(para) {
        return axios.post(BASE_URL + '/kb/kbxm/pdfshow', para, { responseType: 'blob' })
    },
    //文化空间-下载模版文件
    downloadTemplate(sectionId) {
        return axios.post(BASE_URL + `/kb/fhxsc/downloadTemplate/${sectionId}`, '', { responseType: 'blob' })

    },
    importScoreFile(sectionId, fileId) {
        return axios.post(BASE_URL + `/kb/fhxsc/importScoreFile/${sectionId}/${fileId}`)
    },
    // #endregion

    // 符合性审查 - 导出硬件信息
    exportHardwareInfo(para) {
        return axios.post(BASE_URL + '/kb/hardware-info/exportHardwareInfo', para, { responseType: 'blob' })
    },
    //硬件信息分页列表
    pageHardwareInfo(para) {
        return axios.post(BASE_URL + '/kb/hardware-info/page', para)
    },
    // 打印报表-打包下载
    packDownloadReport(para) {
        return axios.post(BASE_URL + `/kb/kbxm/packReport`, para, { responseType: 'blob' })
    },
    // 解密-获取评审结果-长湖监狱
    getPfjgTabsByChjy(para) {
        return axios.get(BASE_URL + '/kb/kbxm/reviewResult', { params: para })
    },
    dcpsjgbByChjy(para) {
        return axios.get(BASE_URL + '/kb/kbxm/exportPsjg', { params: para }, { responseType: 'blob' })
    },
}
export default api;
